import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';
import { rGrupSirket } from '../../../../api/models/rGrupSirket';

export default ApiBaseReducer<pList, IInputDataStateModel<pList, rGrupSirket[]>, rGrupSirket[]>(
  ActionSubTypes.API_GRUPSIRKETLISTELE,
  DefaultInputDataStateModel<pList, rGrupSirket[]>()
);
